export const BILLING_ADDRESS_SCOPE = '[data-form="billing-new-address"]'

export const BILLING_FIELD_LAYOUTS = {
  1: ['full'],
  2: ['half', 'half'],
  3: ['half', 'half', 'full'],
  4: ['half', 'half', 'half', 'half'],
  5: ['full', 'full', 'half', 'half', 'full'],
  6: ['half', 'half', 'full', 'half', 'half', 'full'],
  7: ['half', 'half', 'half', 'half', 'half', 'half', 'full']
}
